import { getFromNow, displayDateWithTodayAndYesterdayPrefix } from 'utils/date';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { Tooltip } from 'ui/tooltip';
import { Caption } from 'ui/theme';
import { Cell, Body2LessMargin, CaptionSecondary, InlineFlex } from './ApiKeysPage.styled';
import {
  NAME_COLUMN_VALUE,
  STATUS_COLUMN_VALUE,
  TYPE_COLUMN_VALUE,
  CUSTOM_EVENT_ALLOW_CREATION_UNTIL,
  LAST_MODIFIED_COLUMN_VALUE,
} from '../constants';
import { ApiKey } from '../types';
import { typeDescriptiveText, prependEllipses, keyTypeLabel } from '../utils';

type CellProps = {
  apiKey: ApiKey;
};

export const NameCell = ({ apiKey }: CellProps) => (
  <Cell>
    <Body2LessMargin>{apiKey[NAME_COLUMN_VALUE]}</Body2LessMargin>
    <Caption>{prependEllipses(apiKey.keyIdentifier)}</Caption>
  </Cell>
);

export const StatusCell = ({ apiKey }: CellProps) => (
  <Cell>
    {apiKey[STATUS_COLUMN_VALUE] ? (
      <Badge variant={BADGE_VARIANTS.RUNNING}>Enabled</Badge>
    ) : (
      <Badge variant={BADGE_VARIANTS.FINISHED}>Disabled</Badge>
    )}
  </Cell>
);

export const TypeCell = ({ apiKey }: CellProps) => (
  <Cell>
    <Body2LessMargin>{keyTypeLabel(apiKey[TYPE_COLUMN_VALUE])}</Body2LessMargin>
    <CaptionSecondary>{typeDescriptiveText(apiKey)}</CaptionSecondary>
  </Cell>
);

export const EventCreationCell = ({ apiKey }: CellProps) => {
  const allowed = typeof apiKey[CUSTOM_EVENT_ALLOW_CREATION_UNTIL] === 'string';
  return (
    <Cell>
      <Body2LessMargin>{allowed ? `Allowed` : 'Blocked'}</Body2LessMargin>
      {allowed && (
        <CaptionSecondary>{`Expires in ${apiKey[CUSTOM_EVENT_ALLOW_CREATION_UNTIL]}`}</CaptionSecondary>
      )}
    </Cell>
  );
};

export const LastModifiedCell = ({ apiKey }: CellProps) => (
  <Cell>
    <Body2LessMargin>
      {displayDateWithTodayAndYesterdayPrefix(apiKey[LAST_MODIFIED_COLUMN_VALUE])}
    </Body2LessMargin>
    <InlineFlex>
      <CaptionSecondary>Created&nbsp;</CaptionSecondary>
      <CaptionSecondary>
        <Tooltip
          isUnderlined
          tooltipContent={displayDateWithTodayAndYesterdayPrefix(apiKey.createdAt)}
        >
          {getFromNow(apiKey.createdAt)}
        </Tooltip>
      </CaptionSecondary>
    </InlineFlex>
  </Cell>
);

export const LastUsedCell = ({ apiKey }: CellProps) => (
  <Cell>
    <Body2LessMargin>{apiKey.lastUsedAt}</Body2LessMargin>
  </Cell>
);
